import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import IconButton from '../IconButton'
import Menu from '../Menu'
import { MenuIcon } from '../icons'
import { HeaderItem } from './types'

interface Props {
  logout: () => void
  headerLinks: HeaderItem[]
  isSettingsAllowed?: boolean
}

const MobileNavigationMenu: React.FC<React.PropsWithChildren<Props>> = ({
  logout,
  headerLinks,
  isSettingsAllowed = false,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const goTo = (path: string) => {
    void navigate(path)
  }

  const menuItems = [
    ...headerLinks
      .map((i) =>
        i.children?.length
          ? i.children.map(({ name, path }) => ({
              content: name,
              action: () => goTo(path),
              selected: location.pathname.includes(path),
            }))
          : {
              content: i.name,
              action: () => goTo(i.to),
              selected:
                location.pathname === i.to ||
                i.children?.some((c) => location.pathname.includes(c.path)),
            }
      )
      .flat(),
    {
      content: 'Profile',
      action: () => goTo('/profile'),
      selected: location.pathname === '/profile',
    },
    ...(isSettingsAllowed
      ? [
          {
            content: 'Organizations',
            action: () => goTo('/organization-settings/dispatch'),
            selected: location.pathname.includes('organization-settings'),
          },
        ]
      : []),
    {
      content: 'Logout',
      action: logout,
    },
  ]

  return (
    <Menu
      right="0"
      top="101%"
      toggler={<IconButton size={36} icon={<MenuIcon />} />}
      items={menuItems}
    />
  )
}

export default MobileNavigationMenu
